module.exports = __webpack_public_path__ + "static/media/_MIC2436.image.98bf2b0e.png";